import { inject, injectable } from 'inversify-props';
import { IHttpClient, ILogger, ISettings } from '../common';
import { PagedResult, Deck } from '../../models';


export interface IDeckFavoriteService  {
	page(deckId: string, pageIndex: number, pageSize: number): Promise<PagedResult<Deck>>;
	list(deckId: string): Promise<Deck[]>;
	add(deckId: string): Promise<any>;
	remove(deckId: string): Promise<any>;
}


@injectable()
export class DeckFavoriteService implements IDeckFavoriteService {

	constructor(
		@inject('IHttpClient') private httpClient: IHttpClient,
		@inject('ILogger') private logger: ILogger,
		@inject('ISettings') private settings: ISettings) { }


	public page(deckId: string, pageIndex: number, pageSize: number): Promise<PagedResult<Deck>> {
		const url = `${this.settings.baseUrl}${this.settings.deckBaseUrl}/favorites/${pageIndex}/${pageSize}`;
		return this.httpClient.get<PagedResult<Deck>>(url);
	}

	public list(deckId: string): Promise<Deck[]> {
		const url = `${this.settings.baseUrl}${this.settings.deckBaseUrl}/favorites/`;
		return this.httpClient.get<Deck[]>(url);
	}

	public add(deckId: string): Promise<any> {
		const url = `${this.settings.baseUrl}${this.settings.deckBaseUrl}/favorites/${deckId}`;
		return this.httpClient.post(url, null);
	}

	public remove(deckId: string): Promise<any> {
		const url = `${this.settings.baseUrl}${this.settings.deckBaseUrl}/favorites/${deckId}`;
		return this.httpClient.delete(url);
	}

}
